/* eslint-disable max-len */
export default {
  header: {
    navigation: {
      home: 'Home',
      downloads: 'ダウンロード',
      twitter: 'Twitter',
      wallet: 'Wallet',
      explorer: 'ブラウザ',
      ecosystem: '生態システム',
      skyminer: 'スカイマイニングマシン',
      hardware: 'Hardware',
      blog: 'ブログ',
      telegram: 'Telegram',
      discord: 'Discord',
      getWallet: 'Skycoinを購入',
      jobs: 'レーバー',
      ecosystem_overview: '概説',
      skywire: 'Skywire',
      skywallet: 'Skywallet',
      obelisk: 'Obelisk',
      fiber: 'Fiber',
      cx: 'CX',
      cxo: 'CXO',
      other: 'その他',
      pressreleases: 'Press Releases',
      gallery: '写真',
      events: 'Events',
      explorerApi: 'ブラウザ API ',
      merchandise: 'ショップ',
      hardwareStore: 'ハードウェアショップ',
      skywallethdk: 'Skywallet HDK',
      whitepaper: 'Whitepapers',
    },
  },
  footer: {
    rightsReserved: 'All rights reserved',
  },
  notFound: {
    404: '404',
    message: 'Whoops! Looks like you\'re lost </br> This page does not exist anymore or has been moved to a new URL',
    title: 'Page not found',
    heading: 'Page not found',
    home: 'Home page',
  },
  getStarted: {
    heading: 'Skycoinへ加入',
    paragraph: 'True decentralization means no government can censor Skywire, no corporate interest can stop it.<br/><br/>The internet began as a community of people wanting to share information — the time has come to bring back that vision of the internet using a cryptocurrency that truly fulfills Satoshi’s vision of a decentralized cryptocurrency with Skycoin.</p>',
    buy: 'Skycoinを購入',
    wallet: '財布をゲット',
  },
  newsletter: {
    heading: '登録して更新を受信',
    button: '登録',
    input: 'メールアドレスを入力',
    skyminerOption: 'I\'m Interested in a Skywire Miner',
  },
  markets: {
    title: 'Buy Skycoin',
    loading: 'Loading, please wait...',
    description: 'Buy Skycoin',
    disclaimer: 'Please note that sending funds to crypto wolf before hitting "Start Transaction" will lead to transaction failure. Moreover, sending a different amount from the one indicated will also lead to transaction failure. Make sure that you have calculated the miner\'s fee in order to send the exact amount indicated',
    data: 'Market Data',
    contact: 'To list Skycoin and put your exchange here email ',
    video: 'How To Buy Skycoin Direct From Skycoin.com',
  },
  home: {
    title: 'Skycoin - Decentralize the Web',
    description: 'Skycoin is a new blockchain-based mesh-internet.',
    banner: {
      heading: 'Skycoinハードウェア展示',
      button: '写真チェック',
    },
    bannerStore: {
      heading: '今日はスカイマイニングマシンを一台注文しましょうか',
      button: 'Visit store',
    },
    hero: {
      heading: 'スカイコインって何？',
      paragraph: 'Skycoin プラットフォームは世界で最も先進なブロックチェーンアプリケーション生態システムである。Skycoinはビットコインとイーサリアムの早期貢献者より共同開発し、完全に安全で、無限拡張可能、ISPから独立しているプラットフォームである。Skycoinはブロードバンド、メモリとコンピューティングを後ろ盾とし、中本聡の当初ビジョンを実現することを目指している',
      slider: {
        revolutionary: {
          title: 'スカイコインは革命的な物です。',
          description: '新しいブロックチェーン生態情報',
        },
        obelisk: {
          title: 'スカイコインはObeliskです',
          description: '一種の新しいコンセンサス、PoSとPoWにおけるコア抵抗率問題を解決できました',
        },
        cx: {
          title: 'スカイコインはCXです」',
          description: '新しくて強くて、ブロックチェーン開発に向けるチューリング完全言語',
        },
        skywire: {
          title: 'スカイコインはSkywireです',
          description: '更に強く、速く、安全なインターネット、ネットワークプロトコルとバンド幅ルーターアルゴリズム',
        },
        fiber: {
          title: 'スカイコインはFiberです',
          description: '無限拡張可能、完全カスタマイズ可能なプラットフォームであり、ビザに類似するスピードやセキュリティ性を備えています',
        },
      },
      buy: 'スカイコイン購を入する',
      wallet: {
        get: '財布をダウンロード',
      },
    },
    about: {
      obelisk: 'OBELISKについて、もっと知りたい',
    },
    network: {
      label: 'Digging deeper',
      heading: 'Obelisk',
      subheading: 'Skycoinコンセンサスアルゴリズム',
      body: 'Skycoinでは、我々は確実に中央権威がなく、分散型のネットワークというユーザの要望を満足させたい。この任務を遂行するために、我々はPoWとPoSを乗り越え、完全に新しい分散型アルゴリズムを作り出し、ブロックチェーンの内部仕組みを作り直した。我々の分布式コンセンサスアルゴリズムObeliskはこのようなネットワークをちゃんと提供できた。<br/><br/>そのネットワーク信頼やコンセンサスメカニズムは集中権力の発展を阻止した。Skycoinには採掘必要がなく、51％の攻撃を免疫し、数秒内に取引が生まれる。全ての決定は少数利益関係者の意思ではなく、地域のコンセンサスによるものである。',
    },
    miner: {
      heading: 'スカイマイニングマシンを検索',
      subheading: 'Skywireマイニングマシンが心を込めた設計や配置をされたもので、Skywireインフラへ盤石な電信主幹ネットワークを提供している。カスタマイズしたハードウェアはSDNへ最高クラスの安全保障、効率や性能を提供する。 マルチアーキテクチャーによって、それぞれのノードはSkywire上の独立サービスをサポートできる。ノード隔離により、それぞれのサービスは外部サービス攻撃をされても、安全に作動できる。サービスを提供するこれらのノードは OpenWRT ルーターに管理されている。ルーターには厳格なデータパッケージ転送やアクセスコントロール規則を備え、予定外な保障を提供する。Skywireネットワークへサービスや安全保障を提供するスカイマイニングマシンは奨励として、コインタイムをゲットできる。',
      link: 'Become a node',
      more: 'もっと知りたい',
      morePhotos: 'もっと多くの写真を見たい',
      headingHardware: 'Skycoinハードウェアセットは継続的に実質化',
    },
    press: {
      heading: 'Skycoin Picked As Top 5 Crypto Projects For 2018',
      subheading: '2019年最も注目価値のあるプロジェクト',
      forbes: 'Skycoin aims to provide a “new internet” that is global, decentralized, and not controlled by any country, corporation, or government entity.  For privacy gurus or net neutrality enthusiasts, this is a project to stay on top of.',
      huffingtonPost: 'Net neutrality and consumer data privacy emerged as two key issues in tech in 2017. If you’re concerned about paying ridiculous fees to ISPs for unreliable coverage, having your data sold, or government monitoring and censorship - Skycoin provides hope. These are the core issues Skycoin is attempting to solve.',
    },
    ecosystem: {
      heading: 'Skycoin プラットフォームは世界で最も先進なブロックチェーンアプリケーションプラットフォーム',
      subheading: 'Skycoin生態システム',
      fiber: {
        title: 'Fiber',
        text: 'Skycoinプラットフォームの無限拡張と、高度カスタマイズ化できる平行同クラスチェーン仕組み。',
      },
      obelisk: {
        title: 'Obelisk',
        text: '「ウェブトラスト」はPoW & PoS基本欠陥を解決するための新しいコンセンサスアルゴリズムである。',
      },
      skycoin: {
        title: 'Skycoin',
        text: '最も強い、最も完全な暗号化通貨プラットフォーム。',
      },
      coinHours: {
        title: 'コインタイム',
        text: 'Skycoinを持つことによって獲得される物であり、コインタイムはSkycoinプラットフォームにおけるサービス決済メカニズムである。',
      },
      coinJoin: {
        title: 'コインタイム',
        text: 'Native platformはコインタイムを対応可能、完全機密で追跡不可な取引を提供する。',
      },
      skyledger: {
        title: 'Skyledger',
        text: 'Platform for launching your very own ICO on top of Fiber, our blockchain technology.',
      },
      skywire: {
        title: 'Skywire',
        text: '新しい分散型インターネット、一種の無線で複数ネットワークにより、あなたをサポートする。',
      },
      skyminer: {
        title: 'スカイマイニングマシン',
        text: '潰れないほど強い分散型インターネットのハードウェアコア。あなたが熟睡中に、ブロードバンド、メモリとCPUを提供することによって、報酬を獲得する。',
      },
      nodes: {
        title: 'ノード',
        text: 'Skywireネットワークの構成部分であり、いなる方でもノードを配置することによって、Skywire生態システムの分散型を確保することができる。',
      },
      cx: {
        title: 'CX',
        text: 'Golangに基づくカスタマイズプログラミング言語。学習しやすくて操作性ある。',
      },
      cxo: {
        title: 'CXO',
        text: 'Skywire分布式ネットワークに向けて設計したポイント対ポイントのクラウドメモリサービス。',
      },
      kittyCash: {
        title: 'KittyCash',
        text: '現在、Fiberの上に構築された最も流行しているアプリケーションプログラム。 Kittycashは完全に猫を動力とするゲーム生態システムである。',
      },
      skyVpn: {
        title: 'SDN',
        text: 'Skywireネットワーク内蔵の端末対端末の仮想個人暗号化機能により、プライベート情報を確保する。',
      },
      skyMessenger: {
        title: 'SkyMessenger',
        text: '完全に暗号化された我々のメッセンジャーサービスによって、洞察や混入者を避ける。',
      },
      bbs: {
        title: 'BBS',
        text: '分布式SNSサービスの枠を構築する。',
      },
    },
    news: {
      heading: 'ニュース',
    },
    signup: {
      heading: 'Skyfleetへ入り、リアルタイムで通信、私達と一緒に空を飛ぼう！',
      body: 'メールを予約してSkycoinチームの最新動向、情報更新を獲得。個人メールアドレスを入力、今すぐ出発！',
      button: '登録',
    },
  },
  downloads: {
    title: 'ダウンロード',
    description: 'SKYCOIN財布をダウンロード',
    wallet: {
      heading: 'SKYCOIN財布をダウンロード',
      headingDaemon: 'Download Skywallet Daemon',
      build: '現在バージョン {version}.',
      macos: 'MacOS',
      linux: 'Linux',
      windows: 'Windows',
      android: 'Android',
      ios: 'iOS',
      androidRecommended: 'Google Play Store',
      androidRecommendedComment: ' (recommended)',
      iosRecommended: 'Apple iOS App Store',
      iosRecommendedComment: ' (recommended)',
      androidAdvanced: 'APK',
      androidAdvancedComment: ' (advanced)',
      withElectron: 'Installer',
      withElectronComment: ' (recommended)',
      withoutElectron: 'Portable',
      withoutElectronComment: ' (advanced)',
      download: 'ダウンロード',
      instructions: 'Instructions',
      signature: 'デジタルサイン',
      torrent: 'Torrent',
      linuxDaemon: 'Daemon',
      linuxDaemonComment: '  ',
      macsDaemon: 'Daemon',
      macsDaemonComment: '  ',
      windowsDaemon: 'Daemon',
      windowsDaemonComment: '  ',
    },
    whitepaper: {
      title: 'Whitepapers',
      description: 'Skycoin wallet Whitepapers.',
    },
    bbs: {
      heading: 'Skycoin BBSをダウンロード',
      lead: 'Skycoin BBSはSkycoinのブロックチェーン技術Fiberを使用して構築した次世代分散型SNSである。',
      githublink: 'Githubで最新のバイナリーファイルを検索',
      thinclient: 'BBS携帯顧客へ',
    },
    whitepapers: {
      heading: 'Skycoinコンセンサス白書をダウンロード',
      download: 'ダウンロード',
      cryptocurrencyNetwork: '暗号化通貨ネットワーク分布式コンセンサスアルゴリズム白書',
      skyFramework: 'Sky：P2Pネットワークでコンセンサスを作る観点動的フレームやモデル',
      skyHashConsensus: 'SkyHash：P2Pネットワークでハッシュコンセンサス観点動的モデル',
      skyHash: 'SkyHash：Hash観点動的モデル',
      sznajd2: 'Sznajd2: 地域意識のある観点動的モデル',
      distributedAlgorithm: '暗号化通貨ネットワークの分布式コンセンサスアルゴリズム',
    },
    assets: {
      heading: 'Skycoinブランドマニュアルをダウンロード',
      guidelines: 'Skycoinブランドマニュアル',
      logo: 'Skycoinの Logo PNGs',
      sch_logo: 'Coin Hours ロゴ',
      font: 'Skycoinの Sansフォント',
      branding: 'Skycoinブランド視覚規範 v1.6.1',
    },
    skywire: {
      heading: 'Skywire',
      installationGuide: 'Skywireインストールガイド v1.0',
      minerAssemblyManual: 'Skywireマイニングマシン組立マニュアル v2.3',
      minerAssemblyManualHiRes: 'Skywireマイニングマシン組立マニュアル Hi-Res v2.3',
      skyminer: 'Skyminerマイニングマシン取付マニュアルv2.2',
    },
    roadmap: {
      heading: 'Roadmap',
    },
  },
  thankYou: {
    message: 'Thank you! Your response has been recorded.',
  },
  ecosystem: {
    title: '生態システム',
    description: '生態システム',
    heading: '生態システム',
    subheading: 'ニューインターネットアーキテクチャー',
    skycoin: {
      heading: 'Skycoin',
      body: 'Skycoinはビットコインとイーサリアムの欠陥を解決するために作られた。Skycoinの出現は当時、完全な分散型デジタル通貨という中本聡の最初の思いを実現できる他のコインがなかったからである。<br/><br/>独自なObeliskコンセンサスアルゴリズムにより、Skycoinのプラットフォームは分散型や人的制御を免れる。その独特なプログラミング言語CXは千や万人の開発者がアプリケーションプログラムをブロックチェーンへ配置することを許容している。Skycoinは暗号化通貨として、無料取引という機能を持ち、絶対プライベート保持機能が間もなく実現し、Visa支払処理システムに類似する速度を備えている。その価値はチャンスをねらう主義ではなく、内在資産サポートに基づくものである。<br/><br/>Skycoinで生まれたコインタイムを持つと、Skywireネットワークからサービスを購入できるだけではなく、より多くのSkycoinの両替できる。</p>',
      btn: 'CXの情報をもっと知りたい',
    },
    skywire: {
      heading: 'Skywire',
      body: '快速：大型ISPみたいに、トラフィック制限や他サービス中断に影響されない。<br/><br/>プライベート保持：プライベート保持は客が閲覧する時に、追跡できないことを意味する。ISPみたいに、毎月に巨大な費用を支払い、客の追跡をしたり、許可なしに客の閲覧データを売却したりするISPのやり方と違って、 Skywire地域はインターネットサービスにより、ユーザのプライベートを保持できる。<br/><br/>インセンティブ：Skywireは無線メッシュネットワーク（WMN）に発展する予定。ユーザはSkycoinとコインタイムを同時にゲットするによって、ネットワーク全体へブロードバンドや記憶を提供するハードウエアノードを稼働させる。ユーザはゲットしたコインタイムで欲しい内容や他のネットワーク資源と交換できる。<br/><br/>セキュリティ：Skywireはユーザ自身より作り、ユーザへサービスする。ユーザはシステムが稼働するネットワークを信頼した上で決断し、地域の集団プロトコルにより、悪意ノードをメインSkywireネットワークから中断させる。このコンセンサスモデルによって、Skywireを攻撃、搾取や操縦を免れる。<br/><br/>ークは正に清流と言えるでしょう。Skywireは権利を大衆に戻しながら、更に強い、速い、安全なインタネットを作ってきている。</p>',
      skywireBtn: 'SKYWIREの情報をもっと知りたい',
      cxoBtn: 'CXOの情報をもっと知りたい',
    },
    obelisk: {
      heading: 'Obelisk',
      body: '権利集中世界での権利分散<br/><br/>Obeliskはプルーフオブワーク(PoW)とプルーフオブステーク(PoS)のアルゴリズムの不足から生まれたものである。Obeliskは永遠にプール集中又は株主の操りにされないことは、本当の分散とは言える。Obeliskは信頼のサイトアーキテクチャーにより、ネットワークへの影響を分配する。ネットワークはマイニングマシンではなく、ノードで構成される。それぞれのノードには自分のブロックチェーンを持つことは、いかなる潜在な不良行為を防止や隔離できる。ビットコイン又はイーサリアムを使用する伝統的なマイニングマシンと比べると、これらのノードの生産、獲得と運営コストは更に低くなる。Obeliskは伸縮可能、計算が安く、無駄ゼロのPoW代替品として設計されている。これらの特性により、アルゴリズムは電力を無駄にしない又は大事な自然資源を消耗しないで、継続可能な方法で安価なハードウェアに稼働できる。ほとんどの人が同じノードを操作できるようになったら、集中化はほぼ不可能になる。</p>',
      btn: 'learn more about obelisk',
    },
    experiments: {
      heading: 'Fiber',
      body: 'FiberはSkycoinプラットフォームを無限拡張と高度カスタマイズ化できる平行同クラスチェーン仕組みである。Fiberはブロックチェーンより良いソリューションであり、現在の分布式帳簿にある技術問題を解決できる。<br/><br/>Fiberは「ブロックチェーン 3.0」の基礎であり、Strand（チェーン）のように並列に設置し、無限拡張可能なブロックチェーンネットワークと記述しても良い。 Fiberにある各会社、各プロジェクトには専用、完全カスタマイズなプライベートブロックチェーンを所有し、その速度がVisaと匹敵できる。それによって、個人又は会社ブロックチェーンの企業へブロックチェーンに関するソリューションを提供し、企業の独自管理を実現し、自社のチェーンを完全にコントロールできるようにする。Fiberに加入したそれぞれのチェーンによって、ネットワーク全体を強化し、全体の生態システム仕組みを構築した。<br/><br/>Skycoinの Fiberは一代目や二代目の暗号通貨アーキテクチャーと競争するのではなく、それらに代わるのである。立ち上げたばかりのブロックチェーンプロジェクトからソリューションを求める会社ならば、Fiberが正にその答え。</p>',
      btn: 'FIBERの情報をもっと知りたい',
    },
    iconLabel: {
      fiber: 'Fiber',
      coinHours: 'Coin Hours',
      cx: 'CX',
      obelisk: 'Obelisk',
      coinJoin: 'Coin Join',
      skyminer: 'Skyminer',
      node: 'Node',
      cxo: 'CXO',
      bbs: 'BBS',
      skyMessenger: 'SkyMessenger',
      skyVPN: 'SDN',
      kittyCash: 'KittyCash',
    },
    about: {
      heading: 'Skycoinって？',
      paragraph1: 'デジタル通貨の最初目的は経済を再生することにある。ユーザが独立に授権され、センター機構に影響されず、対等な方式で取引を行なえるようにすることである。Skycoinにとっては、これが我々の使命である。これはSkycoinが僅かなユーザではなく、全てのユーザの利益を目指す目的である。Obeliskにより、我々はPoWやPoアルゴリズムの固有問題を解決し、顧客様へ分散型民主同認識なネットワークを提供する。',
      paragraph2: '中本聡はビットコインを分散型なデジタル通貨と考えている。ブロックチェーンネットワークは金融を民主化にし、大手会社によるコントロールを除去し、権力を大衆の手に握らせることを目指している。しかし、ビットコインと、PoW/PoSアルゴリズムを使用してマイニングによる奨励を獲得するデジタル通貨はますます中心となってきている。これはデジタル通貨を発明した初心と反している。',
      paragraph3: 'だから、これらの欠陥を埋める為に、我々はSkycoinを作り出した。 SkycoinのブロックチェーンはPoW/PoSに代わる新たな一致性アルゴリズムを使用し、他のブロックチェーンネットワークと接続する時のセキュリティン問題も解決し、新しいコインの生み出しとマイニングを分けた。Skycoinこそ中本聡のビジョンに合うよ真の分散型デジタル通貨である。',
      paragraph4: 'Skycoinブロックチェーンにはマイニングがないので、権力は現在のビットコインのように、幾つかの大きいプールに集中したりしない。新しいコインの生み出しはあるユーザへネットワークに対する不適切なコントロール権力を与えたりしない。 Skycoinの総量が固定され、取引速度が秒単位であり、しかも安全である。ネットワークをコントロールする政治道具ではなく、デジタル財産として、我々はSkycoinという変化不可な暗号通貨を作り出した。',
    },
    roadmap: {
      dev: {
        heading: 'Skycoin発展路線図',
      },
      marketing: {
        heading: 'Skycoin Marketing Roadmap',
      },
    },
  },
  skyminer: {
    title: 'Explore Skyminer',
    description: 'Skywire Miner: hardware for the new internet',
    hero: {
      heading: 'スカイマイニングマシン： <br/>次世代インターネットハードウェア.',
    },
    about: {
      heading: 'スカイマイニングマシンを検索',
      subheading: 'SKYWIREマイニングマシン：新世代インターネットにおけるハードウェア設備',
      paragraph1: 'Skywireマイニングマシンが心を込めた設計や配置により、新世代のインターネットの構築へ柱を提供している。そのカスタマイズハードウェア設備は現有の技術規格を超え、最大な出力や性能を提供している。SkywireはSkycoinを獲得するためのマイニングマシンような存在である。専門なパーチャル専用ネットワークとして、下記ハードウェア配置を備えている。',
      paragraph2: 'それぞれのメインボードにはARMプロセッサ、2 GB RAM、及び16～256 GBのフラッシュメモリを備えている。ハードウェアを分割したこのやり方により、一つのサーバが壊れた場合、同じコンピューターにおける他のサーバーは影響されない。厳格なデータパッケージ転送規則やアクセスコントロールのあるOpenWRTルーターは安全性を向上した。該当配置は更にカスタマイズによって、4、8、16又は32つのメインボードを対応できる。',
      paragraph3: 'Skywireネットワークで運行しているノードは転送トラフィックに対する報酬を獲得する以外、ネットワークインセンティブ奨励をゲットしてネットワークの構築をサポートすることができる。Skywireについては、我々はこのようなネットワークインセンティブ奨励を上げたいと思っている。然し、我々はSkywireマイニングマシンと他のノードを区分するためのメカニズムをまだ制定している。これらのノードはネットワークにおけるいかなる機器でも良い。',
      list: {
        item0: '8つのCPUメインボード',
        item1: 'それぞれのメインボードに2 GB RAMを持つ',
        item2: 'それぞれのメインボードに4个CPUコアを持つ',
        item3: 'それぞれのメインボードに16 GBのメモリを持つ',
        item4: '64ビットLinuxシステム（Debian）',
        item5: 'ギガイーサネット、8 + 1ポートスイッチ',
      },
    },
    video: {
      heading1: 'スカイマイニングマシンは何ですか',
      heading2: 'スカイマイニングマシン概要',
      heading3: 'スカイマイニングマシン開梱',
      more: 'もっと多いビデオ',
    },
    gallery: {
      heading: '写真展示',
    },
    signup: {
      heading: 'スカイマイニングマシン申請名簿に加入',
      body: '次世代インターネットであなたの未来へ席を、今日から！',
    },
  },
  roadmap: {
    title: 'Skycoin Roadmap',
    description: 'Skycoin Roadmap',
    heading: 'Skycoin Development Roadmap',
  },
  skywire: {
    title: 'Skywire',
    description: 'Skywire - The Foundation of a New Internet',
    about: {
      heading: 'Skywireって？',
      subheading: 'SKYWIREは新しいインターネットを創立した',
      quote: '誰でもSkywireへ貢献し、そこから利益を獲得できる。',
      paragraph1: 'Skywireはインターネット開発や使用における次の革命的段階である。我々はインターネットサービス提供業者（ISP）が市場への独占を突破し、ユーザへ自主権を持たせることを期待している。我々は分散型の地域による駆動するメッシュネットワークを通してこの目的を実現しようとし、ユーザ自身がネットワークのインフラを所有し、またコントロールできるようになる。我々の目標は一人一人へ快速、安全、プライベート保持や信頼可能なインターネットを提供することである。',
      paragraph2: '今こそ、ISPを捨てて、前へ向く時期である。伝統的なインターネット利用客はよく追跡される。彼らの閲覧データは ISPに記憶、売却される。それだけではなく、信頼できないネットワークカバーと最悪なカスタマーサービスも直面されている。それに対して、Skywireのメッシュネットワークは会社所有のネットワークに頼るのではなく、幅広いユーザが所有するノードの上で運行する。これらのノードは集合してネットワークへインフラを提供し、地域をインターネットへ接続できるようにする。',
    },
    features: {
      heading: '主な特徴：',
      speed: {
        title: '速いスピード',
        text: '我々が既存ISPサービスを使用する時、インターネットディレー、中断やトラフィック制限など問題にあったことがある。SkywireのプロトコルはSDNに基づくものなので、これによって、時代遅れで低効率の「ホットポテト」（hot-potato）ルーターが歴史となる。Skywireはチャンネルの関連付けを対応可能、この上ない快速な接続を実現できる。信頼性が高く、一回に複数なノードへ接続でき、取扱量や冗長を大幅に向上し、これまで実現困難な応用シーンの民主化を実現する。',
      },
      privacy: {
        title: 'プライベート保持',
        text: '端末から端末までのデフォルト暗号化により、Skywireは全てのトラフィックが機密であり、ユーザのデータが永遠に追跡、記憶や売却されたりしないことを確保する。第三者は単一なデータパッケージをいかなるユーザ又はIPアドレスへ接続できず、ネットワークにおけるいかなる内容も読取ることができない。中継ノードは暗号化データペッケージ伝送における前と後ろのノードのルーター情報を獲得するためにしか獲得できない。最終的に、ユーザはインターネットを楽しみながら、そのプライベートが確実に保護される。',
      },
      security: {
        title: '高い安全性',
        text: '今、インターネットユーザはISPの運営方式に対して、何の発言権も持っていない。Skywireはネットワーク信頼システムにより、ユーザへ決断権を与え直した。コンセンサス方式では、そのノードが悪意ノードと判断されると、切断される。ノード変更が地域全体に信頼できると共同認識された場合、その接続は増強される。一人一人の発言権を確保することによって、Skywireは利用、操り、攻撃されず、すべてのユーザにとっても、更に安全である。',
      },
      ecosystem: {
        title: '自給自足の生態システム',
        text: 'Skywireのコアは地域自体である。我々はノード運営業者へSkycoinとコインタイムを提供することにより、インセンティブ措置を取り、ユーザがネットワークへ貢献するよう励ます。その代わり、ユーザコインをゲットし、コインタイムを使用し、ネットワーク上の資源やアプリケーションサービスを獲得できる。ネットワークは使用さればされるほど、強く、速く、安定になる。それによって、クローズで自給自足な生態経済体系を構築する。',
      },
      internet: {
        title: '新たなインターネットの基礎',
        text: 'Skywireは分布式ブロードバンド、メモリやコンピューティングへ基礎を堅めた。これが新しいP2Pネットワークにとっては、極めて重要なことである。将来、ユーザは安い価格で三つを一つにしたこのデジタル商品を購入でき、Skywireにより、世界の情報を簡単にアクセスできるようになる。近い将来、SkywireやどこにもあるSkywireマイニングマシンはノードを提供し、Skycoinで運行している数々なブロックチェーンアプリケーションが効率的な分散型運用するよう実現させる。',
      },
    },
  },
  cxo: {
    title: 'CX対象システム',
    description: 'CX対象システム',
    about: {
      heading: 'CXOとって？',
      subheading: 'CX対象システム',
      quote: 'Skycoinは新たな生態システムを作ろうとしているが、それが下記の部分を含めている。',
      paragraph1: 'CXO（CX対象システム）は変更不可なSkycoin対象システムであり、Aetherとも言われていた。CXOは現在で伝統的なポイント対ポイントの共有方法の代わりとなる強いメモリシステムを作り出すことを主旨とし、BitTorrent、DropboxとGoogle Driveなどサービスのサービスに代わり、データがSkycoin CXOデータベースにより、ポイント対ポイントのコピーを実現できる。',
      paragraph2: 'CXOはブロックチェーンに基づく他の記憶ネットワークが使用するプロトコルを整合や拡張した。CXOは内蔵方式の IPLDを備えている。このような方式は規制したり、関連データベースを分類したりするために使用できる。惑星間ファイルシステム（InterPlanetary File System、IPFS）はCXOの上で構築できる。CXOが提供したデータはSkywireネットワークに分布し、データセキュリティ、検証可能性の実現をサポートでき、ブロックチェーンに記憶する必要もない。',
      skywire: {
        title: 'Skywire',
        text: 'Skywire-ポイント対ポイント 地域で分散化を駆動',
      },
      cx: {
        title: 'CX',
        text: '規範とプログラミング言語',
      },
      cxo: {
        title: 'CXO',
        text: 'データの共有を実現し、アプリケーションプログラムを記憶するための低クラスデータベース',
      },
    },
    features: {
      heading: '主要な機能：',
      sharing: {
        title: 'データ共有',
        text: '共有した情報のデータ所有者にとっては、非常に役に立つ。パブリックキーなど多くの情報を共有できるから。 CXOノードは情報源を引用することによって、更に多くの情報を受信できる。また、サーバーを使用や発見し、接続することによって、興味に応じるデータを獲得できる。',
      },
      privacy: {
        title: 'プライベート',
        text: 'CXOデータはインターネットに集中存在する。データが発表されると、消去できなくなる。そのデータは対等ユーザ（引用者）にダウンロードされる。プライベート情報を守るために、発表者の位置は追跡できない。発表者は分散化ネットワークにおける一つのポイント（対等ユーザ）に過ぎないから。',
      },
      security: {
        title: '高い安全性',
        text: 'CXOは自給自足な標準生態システムに存在する。しかも、この生態システムのデータが正確であり、ゼロから作り出した生態システムである。所有者がプライベートキーでデータを発行し、データを受取るユーザがパブリックキーで審査や署名できる。それによって、データが予測の情報所有者から来たものだと確保する。データ所有者のプライベートキーがないと、ノードがデータを変更できないので、データの安全を保障できる。',
      },
      apps: {
        title: 'CXOアプリケーション',
        text: 'CXOにおけるアプリケーションは現在、少量なテストを行なっている。SkyBBSはFacebook、SteemitやTwitterに類似するSソーシャルネットワークであり、しかも、CXOの上に構築されたものである。もっと沢山のアプリケーションを発表するので、お楽しみにして下さい。',
      },
    },
  },
  cx: {
    title: 'CX - プログラム設計言語',
    description: 'CX - プログラム設計言語',
    about: {
      heading: 'CXって？',
      subheading: 'プログラム設計言語',
      paragraph1: 'CXはSkycoinの規範であり、プログラミング言語でもある。豊富な機能を備えている。CXはSkycoinプロジェクトで多くの改善を示される。安全性を考慮した複雑契約プロトコルの作成を許容する。',
      paragraph2: 'CXはプラットフォームでの項目へ修正可能な義務を配置する。これらの属性は全部、CX多目的プログラミング言語の一部：',
    },
    features: {
      heading: 'CXの特徴：',
      affordances: {
        title: 'アフォーダンス',
        text: 'アフォーダンスは特定ユーザの権限授与や拒否に使用できる。これがプログラマーが自信を持って安全コードを作ることに役に立つ。アフォーダンスシステムを検索することによって、機能をカバーする操作リストを獲得できる。',
      },
      programming: {
        title: '遺伝的プログラミング) ',
        text: '遺伝的プログラミングはCXプログラム作成中における一種の進化である。機器学習ツールの一種として、GPは問題自動解決メカニズムの提供とカーブフィッティングの実行や、予測モデル作成の能力をもってプログラマーをサポートする。',
      },
      deterministic: {
        title: '決定性言語',
        text: '決定性により、CXプログラムが信頼的に作成されることを許容し、プログラマーが組込み環境におけるデッキー機器の需要を考慮することをなくした。どんな機器の誕生も、生産されたからである。',
      },
      typing: {
        title: '厳格なタイプシステム',
        text: 'CXの厳格タイプシステムはもう一つのクラス又は冗長を提供し、使用が便利で、調整も簡単で明確。表示種類変換のミスが減り、CXは本質的にプログラマーにとっては、安全である。',
      },
      complied: {
        title: 'コンパイルとインタプリタ言語',
        text: 'コンパイルとインタプリタ言語の機能を兼備している。これによって、プログラマーはその高級特性を利用し、柔軟性やインタラクティブ機能を追加できる。',
      },
      garbage: {
        title: 'ガベージコレクタ',
        text: 'CXガベージコレクタは自動内蔵メモリ管理方式の一つであり、キューにある未使用な対象を自動的に回収し、必要な操作のために価値のあるメモリを釈放する。CXはプログラムで将来にアクセスできないデータ対象を検索し、それを処分する。',
      },
      object: {
        title: '対象リソースマネージャー',
        text: 'プログラマーは一つの対象リソースマネージャーをアクセスできる。該当リソースマネージャーはすべての対象及びその現在メモり分配の図形画面を表示する。これらの対象がシリアル化や伝送されるが、コード手順によって、プログラマーが最後に観察した状態でこれらの対象への実行を復元することができる。',
      },
    },
    roadmap: 'Skycoin路線図',
  },
  jobs: {
    title: 'Skycoin is hiring developers.',
    subtitle: 'We are hiring',
    sidebarTitle1:
      'Apply for a job by sending an email to jobs@skycoin.com with the following information:',
    sidebarTitle2: 'with this information:',
    sidebarList: {
      item_1: 'Position desired',
      item_2: 'Name',
      item_3: 'Time zone',
      item_4: 'Full-time or part-time',
      item_5: 'Telegram username',
      item_6: 'Resume (PDF)',
    },
    ourProject:
      'All of our projects are developed in Go and C. For frontend work, we use ',
    angular: 'Angular',
    or: ' or ',
    react: 'React.js.',
    ourTeam:
      'Our team is spread across the world and you will be working either remotely or at one of our offices in Shanghai. We communicate using',
    accordion1: {
      title: 'Technical Writer',
      responsibilities: {
        title: 'Responsibilities',
        item1:
          'Work on a remote team to create articles to communicate technical progress to readers',
        item2: 'Create and update technical documentation',
        item3: 'Create user manuals for various Skycoin projects',
      },
      requirements: {
        title: 'Requirements',
        item1:
          'Excellent English reading and writing skills as well as previous experience with technical writing.',
        item2:
          'Knowledge of concepts and technologies used in the software development process.',
      },
    },
    accordion2: {
      title: 'Software Engineer (Backend)',
      description:
        'Work on a fully remote team developing blockchain-, networking- and infrastructure-related software. Experience writing in Go (Golang) required.',
      projects: {
        title: 'A Sample of Active Projects',
      },
    },
    accordion3: {
      title: 'Firmware Engineer',
      description:
        'Work on a fully remote team developing firmware and embedded software for various hardware projects.',
      projects: {
        title: 'A Sample of Active Projects',
      },
    },
    accordion4: {
      title: 'Circuit Engineer',
      description:
        'Study relevant technical materials to compile the proper English materials for foreign members making up 80% of total team members. Good proficiency in English reading and writing is a requirement for admission.',
      responsibilities: {
        title: 'Responsibilities',
        item1:
          'Draw PCB Design drawing and circuit schematic diagram according to product requirements;',
        item2:
          'Edit the instruction documents for production, such as BOM format and screen mesh;',
        item3:
          'Carry out the selection of components and be in tune with suppliers on product supply;',
        item4: 'Carry out type testing and reliability testing;',
        item5: 'Write technical documents and file them.',
      },
      requirements: {
        title: 'Requirements',
        item1:
          "Hold a bachelor's degree or above in electronic engineering or related discipline;",
        item2:
          'Possess very strong English reading and writing skill in response to the search and quick study of technical materials and the daily conversation in an English-speaking environment;',
        item3:
          'Process the ability to proficiently design analog circuits and digital circuits, and read and draw schematic diagram skillfully;',
        item4:
          'Use Altium Designer or other same type software skillfully in response to the independent conduct for layout design of four-layer PCB board.',
        item5:
          'Possess the strong ability to circuit adjustment and test, and use common instruments skillfully;',
        item6:
          'Have a certain understanding of the model and supply chain of ordinary electronic components;',
        item7:
          'Think clearly, take initiative in working process, hold the ability in both strong executive and excellent self-study, and maintain good teamwork spirit.',
      },
      priority: {
        title:
          'High-priority candidates include those with any of the following conditions',
        item1:
          'Possess the ability to be familiar with English materials on Electronics Industry or the English-speaking proficiency;',
        item2:
          'Enable to use SolidWorks and other same types of 3D modeling software and to read mechanical drawings;',
        item3:
          'Have experience in the development of mechanical control programs, Raspberry Pi or Arduino;',
        item4:
          'Have knowledge or experience in any one of the following three sectors--- the Internet of things, communication, and integrated circuits;',
        item5: 'Understand the knowledge of blockchain well;',
      },
      program: {
        title: 'Internship Program',
        item1:
          'Submit at least one work about PCB Design, and relevant cites must be marked if any;',
        item2:
          'Welcome to all of outstanding undergraduates and fresh graduates to take part in internship plan. Upon completion of the internship period, satisfactory trainees shall be given permanent posts.',
      },
    },
    accordion5: {
      title: 'Mechanical Engineer',
      description: 'Description',
      study:
        'Study relevant technical materials to compile the proper English materials for foreign members making up 80% of total team members. Good proficiency in English reading and writing is a requirement for admission',
      responsibilities: {
        title: 'Responsibilities',
        item1:
          'Engage in design, study and optimization for the structure of mechanical products, creation of products, and improvement of product performance and quality;',
        item2:
          'Choose component, set up model machine, test product, and provide technical support for subsequent development work;',
        item3:
          'Solve problems during product development work and meet new requirement from users;',
        item4:
          'Provide the volume production of products with relevant technical data;',
        item5:
          'Play an active role in other aspects of company business needs.',
      },
      requirements: {
        title: 'Requirements',
        item1:
          "Hold a bachelor's degree or above in mechanical engineering or related discipline;",
        item2:
          'Possess very strong English reading and writing skill in response to the search and quick study of technical materials and the daily conversation in an English-speaking environment;',
        item3:
          'Use SolidWorks or related software proficiently in response to the independent conduct for establishment, modification and derivation of model. Experience in designing and managing model documents with components whose total volume is more than 100 are preferred;',
        item4:
          'Understand the supply chain of ordinary mechanical components well;',
        item5:
          'Think clearly, take initiative in working process with the ability in both strong executive and excellent self-study, and maintain good teamwork spirit.',
        item6: 'Must be on site in Shanghai.',
      },
      priority: {
        title:
          'High-priority candidates include those with any of the following conditions',
        item1:
          'Possess the ability to be familiar with English materials on machinery industry or English-speaking proficiency;',
        item2:
          'Understand circuit knowledge and use Altium proficiently for completing the PCB Design;',
        item3:
          'Have experience in the development of mechanical control programs, Raspberry Pi or Arduino;',
        item4: 'Understand the knowledge of blockchain well;',
      },
      propgram: {
        title: 'Internship Program',
        item1:
          'Submit at least one model completed by using Solidworks, and relevant cites must be marked if any;',
        item2:
          'Welcome to all of outstanding undergraduates and fresh graduates to take part in internship plan. Upon completion of the internship period, satisfactory trainees shall be given permanent posts.',
      },
    },
    accordion6: {
      title: 'Industrial Designer OR Intern',
      description: 'Description',
      subtitle:
        'Study relevant technical materials to compile the proper English materials for foreign members making up 80% of total team members. Good proficiency in English is a requirement for admission',
      responsibilities: {
        title: 'Responsibilities',
        item1: 'New product exterior design and 3D modeling;',
        item2:
          'Choose component, set up model machine, test product, and provide technical support for subsequent development work;',
        item3:
          'Provide the volume production of products with relevant technical data;',
        item4:
          'Play an active role in other aspects of company business needs.',
      },
      requirements: {
        title: 'Requirements',
        item1:
          "Hold a bachelor's degree or above in product design or related discipline;",
        item2: 'Have had one-year experience working in relevant sector;',
        item3: 'Have fluent English speaking, reading and writing;',
        item4:
          'Use SolidWorks or relevant 3D modeling software skillfully in response to the independent conduct for establishment, modification and derivation of model.',
        item5:
          'Possess the ability to be familiar with processing technology of common materials, and have a certain understanding of the supply chain for relevant parts;',
        item6:
          'Possess the ability to outstanding aesthetic judgment and creative thinking skill, take initiative in working process, good cooperation spirit and will of study. ',
        item7: 'Must be on site in Shanghai.',
      },
      priority: {
        title:
          'High-priority candidates include those with any of the following conditions',
        item1:
          'Possess the ability to read mechanical drawings or electrical drawings;',
        item2:
          'Use Adobe Illustrator or other same type graphic design software proficiently;',
        item3: 'Understand the knowledge of blockchain well;',
      },
      program: {
        title: 'Internship Program',
        item1:
          'Submit at least one design work completed independently and its introduction;',
        item2:
          'Welcome to all of outstanding undergraduates and fresh graduates to take part in internship plan. Upon completion of the internship period, satisfactory trainees shall be given permanent posts.',
      },
    },
    accordion7: {
      title: 'Blockchain Internship Engineer',
      description:
        'Carry out 90% of the tasks in English and work together with English-speaking members making up 80% of total team members. Good communication skills and proficiency in English are requirements for admission; experiences in large international companies are preferred. Upon completion of the internship period, satisfactory trainees shall be given permanent posts.',
      responsibilities: {
        title: 'Responsibilities',
        item1:
          'Study the principle of blockchain, operation mechanism and relevant algorithms;',
        item2:
          'Take part in the design, development and testing of blockchain products;',
        item3:
          'Solve problems during development and testing, and provide technical support for products;',
        item4: 'Write technical documents and file them.',
      },
      requirements: {
        title: 'Requirements',
        item1:
          'Undergraduates and fresh graduates majoring in computer science, software engineering, or related specialists;',
        item2:
          'Process the outstanding ability to excellent communication skills and good English reading and writing skills, and to learn code and relevant technical materials well;',
        item3:
          'Be passionate about the programming, be fond of studying technique, and be strongly interested in the blockchain technology;',
        item4:
          'Be proficient in at least one of the following sectors--- C/ C++, JAVA, GoLang, and Swift Programming Language development, and have good habits of programming and proficiency in file compilation;',
        item5: 'Have experience in developing Linux platform;',
        item6:
          'Master the technique in data structure and algorithm, and be familiar with network protocols such as TCP/IP, HTTP and P2P;',
        item7:
          'Think clearly, take initiative in working process, hold the ability in excellent self-study, and maintain good teamwork spirit.',
        item8:
          'Submit your GitHub account and at least one work, and relevant cites must be marked if any;',
      },
      priority: {
        title:
          'High-priority candidates include those with any of the following conditions',
        item1:
          'Possess the ability to be familiar with relevant professional English vocabularies, and to communicate and express English freely;',
        item2:
          'Have experience in research, development and practitioner of the projects related to blockchain;',
        item3:
          'Have experience in the network protocol development, such as DNP, P2P, etc. ',
      },
    },
    accordion8: {
      title: 'Operations Manager',
      description:
        'This is a flexible position. The operations manager will be responsible for improving internal business processes and leading teams for various business goals as needed. Strong communication and organizational skills are required. Work position is remote or on-site in Shanghai.',
    },
    accordion9: {
      title: 'Marketing Manager',
      responsibilities: {
        title: 'Responsibilities',
        item1:
          'Build, optimize and scale effective marketing campaigns to drive growth across digital marketing channels',
        item2:
          'Identify and test new innovative growth opportunities to deliver on goals',
        item3: 'Collaborate with internal teams / vendors',
        item4: 'Manage performance metrics and budget tracking',
        item5:
          'Generate and create data driven hypotheses to execute experiments across the marketing funnel to optimize conversion and other key performance metrics',
        item6:
          'Execute global marketing strategies with integrated campaigns focusing on user acquisition and brand awareness',
        item7:
          'Coordinate with content writers and social media manager to ensure message consistency across various channels',
        item8:
          'Tell stories with data, transforming it into insightful and easy to interpret visuals',
        item9: 'Maintain brand voice, design and messaging',
        item10:
          'Work closely with the Product and Engineering teams to launch features and products',
      },
    },
    accordion10: {
      title: 'Social Media Manager',
      responsibilities: {
        title: 'Responsibilities',
        item1: 'Represent our brand on social media channels',
        item2:
          'Deliver engaging and inspiring messages to our social audiences, with the goal of driving brand awareness and consideration',
        item3: 'Significantly grow our audience on social media',
        item4: 'Define and implement paid and organic growth strategies',
        item5:
          'Turn our high level marketing strategy into a social media strategy and calendar',
        item6: 'Prioritize between channels, posts and messages',
        item7:
          'Work together with influencers, internal, and external teams to build social content that engages and inspires large customer audiences',
        item8: 'Scale our social content across multiple markets and languages',
        item9: 'Drive engagement with our social community',
        item10:
          'Ensure communication excellence and convert audience feedback into reputation/brand-building moments',
        item11:
          'Drive and develop customer understanding through insightful analyses and actionable reporting',
        item12:
          'Work closely together with the marketing manager to drive a consistent and differentiated brand message to a mix of countries and audiences',
      },
    },
    accordion11: {
      title: 'Content Writer',
      requirements: {
        title: 'Requirements',
        item1: 'Strong knowledge in various media and marketing channels',
        item2: 'Must be able to write content that is SEO friendly',
        item3:
          'Candidate needs to be self-motivated, detail-oriented, problem solving and able to work as a team with staff and administrators; have excellent communication and organization skills',
        item4: 'Must have a popular blogging experience',
        item5: 'Highly proficient in Cryptocurrency and blockchain technology',
        item6: 'Adobe Photoshop basic skills',
        item7: 'Creative thinking skills',
        item8:
          'Strong proficiency in the English language and excellent writing skills',
        item9:
          'Ability to translate complex technical concepts into easily comprehensible articles',
        item10: 'Excellent writing, analysis, and research skills',
      },
    },
    accordion12: {
      title: 'SEO Engineer',
      description:
        'The SEO Engineer will devise and implement SEO strategies on our website properties and in external SEO campaigns.',
    },
  },
  whitelist: {
    heading: 'Skywire Testnet Reward Application Form',
    signUp: {
      title: 'Skywire Testnetへ接続加入しよう&早速に奨励をゲット！',
    },
  },
  fiber: {
    title: 'Fiber',
    description: 'ブロックチェーン3.0には先進的な同業チェーンアーキテクチャーの革新を備えている',
    about: {
      heading: 'Fiberって？',
      subheading: 'ブロックチェーン3.0には先進的な同業チェーンアーキテクチャーの革新を備えている',
      quote: 'SkycoinのFiberアーキテクチャーは革命的、ブロックチェーンより良いソリューションであり、分布式帳簿技術で現在の問題を解決した。Fiberはブロックチェーン3.0の基礎であり、糸の束みたいに平行に並び、無限伸縮可能なブロックチェーンネットワークと記述しても良い。これはビットコイン又はイーサリアムなど暗号化通貨は永遠に実現できな技術壮挙である。今まで、無限という規模まで設計されたことがないから。」',
      author: 'メディア源',
      paragraph1: 'FiberはSkycoinブロックチェーンプラットフォームの構造クラスであり、いかなるブロックチェーンアプリケーションプログラムの需要を対応するために、カスタマイズされたものである。Fiberは革新的で非常に有効なコードの上に運行され、Skycoinプラットフォームがブロックチェーンソリューションによってすべての業界を拡大し、転覆させる。',
      paragraph2: 'Fiberは複雑でありながら優雅でもある。各種な分布式アプリケーションプログラムの需要を拡張や適応できる。',
    },
    features: {
      heading: 'Fiberの優位性',
      system: {
        title: '共に生きる真の対等チェーンシステム',
        text: 'SkycoinのFiberアーキテクチャーはSkycoinプラットフォームに対する横や縦方向の伸縮をサポートするが、規模上で依存関係やネットワーク欠陥を損害させたりしない。Skycoinの<a href="https://medium.com/skycoin/skycoin-obelisk-8cc32bc9ca37" target="_blank" rel="noopener noreferrer">Obelisk</a>コンセンサスメカニズムのおかげで、Fiberがサポートする各トークンは根本的に他のトークンと隔離するので、ネットワークの安定性、安全性又は取扱量などでお互いへ影響しない。また、Skycoinの<a href="https://medium.com/skycoin/skycoin-coin-hours-f537fa7ae614" target="_blank" rel="noopener noreferrer">コインタイムシス</a>テムにより、Fiberを利用するすべてのプロジェクトは現在プラットフォームを影響しない前提で、Skycoinプラットフォーム全体の発展を推進する。',
      },
      forking: {
        title: '適切な分岐処理',
        text: 'Fiberで運行するトークンはSkycoinコアコードの分岐となるので、これはそれぞれのプロジェクトがSkycoinと同様な高級特性、取扱量、安全性を持つようになると意味している。',
      },
      blockchain: {
        title: 'カスタマイズ化のブロックチェーン',
        text: 'Skycoin Fiberで運行しているプロジェックトに独特な需要を対応するために、対して、そのt完全に独立で高度カスタマイズ化なブロックチェーンを所有できる。根本的で言うと、一式の規則又は操作は各種プロジェクトの要求に満足するのであれば、適応性がブロックチェーンプラットフォームにおける最も重要な要素であることが分かる。このプラットフォームの目標は横方向と立方向の拡張を成功に行なうことである。',
      },
      token: {
        title: '真のトークンサポート',
        text: 'Skycoin Fiberアーキテクチャーに基づくトークンは今までないネットワークサポートを得られる。トークンは我々が作り出したポイント対ポイントネットワーク、Skywireで運行でき、それぞれのトークンがSkycoin生態システムで直ちに財布と交換サポートを獲得できる。一つのプロジェクトは世界クラスの我々プラットフォームで数分間内にスタートや取引できる。',
      },
      operation: {
        title: '独立な操作',
        text: 'Skywireが世界でポイント対ポイントマルチネットワークに発展するとともに、Skywireで運行している光ファイバートークンは伝統ネットワークインフラ(ISPなど)への依存から完全に独立する。このプラットフォームの独立性はSkycoin Fiber及びその分布式アプリケーションとプロジェクトが独自に所有しているものである。',
      },
    },
  },
  skyminerForm: {
    title: '登録して更新を受信',
  },
  obelisk: {
    title: 'Obelisk',
    description: 'Obelisk - The Revolutionary Skycoin Consensus Algorithm',
    about: {
      heading: 'Obeliskって？',
      subheading: '革命的なSKYCOINコンセンサスアルゴリズム',
      quote: '「分散型問題、51%の攻撃、マイニング問題、取引速度緩慢とエネルギー浪費は従来のコンセンサスアルゴリズムが直面している幾つかの中心課題です。これらの問題を解決するために、SkycoinはObeliskを開発した。これは新しい分布式コンセンサスアルゴリズムであり、今まで数世代の人々が直面した問題を解決してきました。」',
      author: '（マスコミから）',
      paragraph1: 'Obeliskは革命的なweb-of-trustコンセンサスアルゴリズムであり、今まで数世代のコンセンサスがブロックチェーン分野で発生した問題を消去するために使用される。Web-of-trustシステム仕組みは完璧な検査とバランスシステムを構築し、地域とその他のノードが高い正確度でネットワーク効果を審査することができる。',
      paragraph2: '不審ノードによる悪意行為を切断できるので、ネットワークが更に強くなれる。信頼があるから、維持される。ノードか栗は管理信頼できる。また、この過程では、地域がネットワークにおける権力のバランスと見直すことができる。',
    },
    features: {
      heading: 'Obeliskの特徴',
      consumption: {
        title: '低エネルギー消耗と高い拡張性',
        text: 'コンセンサスアルゴリズムは伸縮可能、且つコンピューティングコストの安いプルーフオブワーク(PoW)の代替案として設計されたので、アルゴリズムとブロック制作も安価なオープンソースハードウェアで運行できる。',
      },
      attack: {
        title: '51%の攻撃に対して免疫',
        text: 'Web-of-trustのコンセンサスは中心型集権の発展を阻止した。Skycoinはマイニング動機に頼らないので、PoW/PoSセキュリティホールに影響されない。',
      },
      defence: {
        title: '盤石な防御',
        text: 'Obeliskはしっかりと組織される悪意ノードネットワークによる大規模な協調攻撃を耐えられる。このアルゴリズムはイテレーションではなく、収束率が速く、マルチホップネットワークみたいに、ノードの分散配列で運行でき、最寄隣接の貫通性しか持っていない。',
      },
      structure: {
        title: 'ダブルノード仕組み',
        text: '一つのコンセンサスノードは一つ又は複数なブロックからノードを生成し、そのインプットを受信する。各種のアルゴリズムは独立しているが、すべてが同じデータ構造で運行している。二種類のノードはアップロードされたデータに対して、授権検証や詐欺検知を実行する。詐欺又は無効なメッセージは検知、削除され、永遠に拡散されないので、不審活動を行なう対等ノードは切断され、そのパブリックキーが禁止される。',
      },
    },
  },
  gallery: {
    title: 'Gallery',
    description: 'Gallery',
    heading: 'Gallery',
    antennas: {
      heading: 'Biquad Yagi Antenna',
    },
    wallet: {
      heading: 'Skywallet',
    },
    skyminer: {
      heading: 'Skyminer',
    },
    diySkyminer: {
      heading: 'DIY Skyminers',
    },
  },
  landing: {
    skyware: {
      hero: {
        title: 'Skywire',
        heading: 'Skywire is the next evolutionary step in the internet’s development and use. Our goal is to provide everyone with access to fast, secure, private and reliable internet.',
        button: 'Learn more',
      },
      watchNow: {
        title: 'Watch now!',
        description: 'Check out these YouTube videos to learn more about Skywire',
        youtube: {
          what: 'What is Skywire?',
          solution: 'A Solution to Censorship',
          isp: 'Why ISPs need to be Replaced',
        },
      },
      afee: {
        text: '“To free Crypto from the bonds of corrupt power, we need more than distributed exchanges. We need to bypass the existing Internet. Mesh networks solve this problem. Skywire  is the only one designed by and for the Crypto Space.” ',
        name: 'John McAfee',
      },
      divider: 'Everyone will be able to contribute to and benefit from Skywire',
      bottom: {
        text: 'Its <b>private</b>, <b>secure</b> and <b>decentralized</b>. Join over 1,450+ nodes now on Skywire with our current special promotion!',
      },
      features: {
        speed: {
          title: 'Speed',
          description: 'Skywire’s protocol is based on software-defined networking, which will make the outdated and inefficient  “hot-potato” packet routing a thing of the past.',
        },
        privacy: {
          title: 'Privacy',
          description: 'With default end-to-end encryption, Skywire ensures that all traffic is private and users will never have  their data tracked, stored, or sold.',
        },
        security: {
          title: 'Security',
          description: 'Today, internet users have no say in how ISPs operate. Skywire gives this decision making power back to  the community in the form of a web-of-trust system.',
        },
        ecosystem: {
          title: 'Self-sustaining ecosystem',
          description: 'By providing Skycoin and Coin Hour rewards to  node operators, we offer incentives for people to contribute to the network.',
        },
        internet: {
          title: 'Foundation of the new internet',
          description: 'Skywire lays the foundation for distributed bandwidth, storage, and computation essential to the new  peer-to-peer internet',
        },
      },
    },
    skywallet: {
      hero: {
        title: 'Skywallet',
        heading: 'Your hardware multi-coin wallet is your bank vault and it should feel like a premium and secure device.  Shipping Q1 2019. Order now!',
        button: 'Order now',
      },
      features: {
        live: {
          title: 'Skywallet Live',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.',
        },
        security: {
          title: 'Security',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ',
        },
        support: {
          title: 'Customer support',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ',
        },
        intuitive: {
          title: 'Intuitive',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ',
        },
        included: {
          title: 'Included',
          description: 'TODO',
        },
      },
    },
    skyminer: {
      title: 'Skyminer',
      description: 'Skyminer',
      hero: {
        title: 'Skyminer',
        heading: 'The Skywire "miner" is meticulously designed and configured to provide a backbone for the new internet.',
        button: 'Learn more',
      },
      hardware: {
        title: 'Hardware',
        description: `
          <li>8 CPU boards</li>
          <li>2 GB of RAM per board</li>
          <li>4 CPU cores per board</li>
          <li>16 GB of storage per board</li>
          <li>64-bit Linux (Alpine Linux)</li>
          <li>100 Mbps Ethernet, 8+1 port switch</li>
        `,
      },
      operate: 'Operate your Skyminer on the Skywire network to <b>get paid</b> SKY for free!',
      watchNow: {
        title: 'Watch now!',
        description: 'Check out these YouTube videos to learn more about Skyminers',
        youtube: {
          video1: 'What is a Skyminer?',
          video2: 'Unboxing the Skyminer',
          video3: 'Introducing the Skyminer',
        },
      },
      support: {
        title: 'Excellent support',
        description: 'When purchasing a Skyminer you will get access to fast email support from our help desk ticket system.  Our Telegram community offers help as well with over 2000 members.',
      },
      orderNow: {
        text: `Its <b>private</b>, <b>secure</b> and <b>decentralized</b>. 
          Join over 1,450+ nodes now with our current special promotion!`,
      },
      forbes: {
        description: '“Skycoin aims to provide a new internet that is global, decentralized, and not controlled by any country, corporation or government. For privacy gurus or net neutrality enthusiasts… this is a project to stay on top of.”',
      },
    },
  },
  exchanges: {
    any: 'Any',
    title: 'Exchanges',
    description: 'Exchanges',
    exchanges: 'Exchanges',
    empty: ' ',
    lbank: 'LBank',
    c2cx: 'C2CX',
    bitbns: 'Bitbns',
    xbts: 'XBTS',
    coindcx: 'CoinDCX',
    table: {
      headers: {
        name: 'Name',
        link: 'Link',
        markets: 'Markets',
      },
    },
  },
  pressreleases: {
    any: 'Any',
    title: 'Press Releases',
    description: 'Press Releases',
    pressreleases: 'Press Releases',
    releases: {
      title: 'Skycoin Announces Public Release of Skywire Mainnet',
      description: 'Skycoin Announces Public Release of Skywire Mainnet',
      dates: 'March 20, 2019',
      content: {
        description: '<p>Skycoin has unveiled the developer version of their Skywire application. Developers will now be able to download, install, build, and run the Skywire mainnet utilizing a command line interface. Full developer documentation will be released over the next few weeks.</p><p><strong>SHANGHAI, March 19, 2019 /PRNewswire/ </strong>-- Work on Skycoin began in 2011 with the merging of three separate projects that aimed to improve upon the design and implementation of Bitcoin. The Skycoin developers identified several major philosophical design issues that they saw as obstacles to global use of cryptocurrency as a censorship-resistant payment system.</p><p>Skywire, the decentralized internet protocol and mesh network, was created as a solution to answer many of these problems.</p><p><strong>Skywire Mainnet is here for Developers to Test</strong></p><p>After about ten months of intensive testing on a network of nearly 10,000 nodes spanning the globe, Skycoin is happy to announce that the developer version of Skywire&apos;s mainnet is now available to the public. Its official launch date was the 4th of March 2019.</p><p>This first iteration of Skywire&apos;s mainnet features entirely rewritten software from the ground up and is primarily focused on a platform for developers to start building the next generation of distributed apps. All existing apps have been rewritten and optimized for the mainnet including a distributed and secure chat app, SSH, and a multi-hop tunneling proxy app. Many more will be coming soon.</p><p> <a href="https://www.blog.skycoin.com/posts/skywire-mainnet-public-testing-announcement/" rel="noopener noreferrer" target="_blank">This first version of Skywire&apos;s mainnet represents a huge milestone for Skycoin and for the future of the internet.</a> Skywire will serve as an unstoppable, highly resilient network, removing any possibility of censorship. </p><p>Skywire mainnet&apos;s developer build is the first release of many. Over the course of the next few months, Skycoin will be releasing new iterations and features for Skywire – one of these is an updater that allows Skycoin to push new features constantly – stay tuned for additional information, technical details, and further updates from the team.</p><p> <a href="https://github.com/skycoin/skywire/tree/mainnet" rel="noopener noreferrer" target="_blank">Skywire Mainnet on Github</a> </p><p>Please note: Do not install this on your skyminers as they are running testnet and will stop receiving rewards. Skywire mainnet can be installed on any other device to run, test and develop.</p><p>Bug reporting should be done through the repo, with steps taken to reproduce any feedback. Details of the process will be available in the readme section of the branch.</p><p><strong>What&apos;s Next for Skywire?</strong></p><ul> <li>A new and intuitive UI for developers and users to easily interact with the mainnet</li><li>Bandwidth monetization will be coming soon that will allow users to earn Coin Hours through bandwidth sharing</li><li>Coin Hours bank</li><li>Private Skycoin transactions utilizing CoinJoin</li><li>Remote management of unlimited nodes</li><li>Combining the CXO protocol with Skywire for distributed data storage</li></ul> <p><strong>About Skycoin</strong></p><p>Skycoin is a third generation blockchain company that has its own chain, consensus algorithm, programming language, hardware, and their flagship product Skywire which is a decentralized community-driven mesh network where users themselves will own and control the network&apos;s infrastructure. Skywire&apos;s goal is to provide everyone with access to fast, secure, private and reliable internet.</p>',
      },
    },
    releases_part: {
      title: 'Early Bitcoin and Ethereum Developers Set to Roll-Out "Skywire" - a New, Decentralized Internet from Skycoin',
      description: 'Early Bitcoin and Ethereum Developers Set to Roll-Out "Skywire" - a New, Decentralized Internet from Skycoin',
      dates: 'August 23, 2019',
      content: {
        description: '<p>Skywire is Designed to Eliminate the Privacy and Security Issues Found on the Internet</p><p><strong>SHANGHAI, CHINA / ACCESSWIRE / August 23, 2019 /&nbsp;</strong>After nearly a decade of development, the team behind the third-generation cryptocurrency Skycoin are ready to unveil their groundbreaking flagship project: a new, decentralized Internet called Skywire. Built from the ground up using cutting-edge new technology, Skywire was designed to completely eliminate the privacy and security deficiencies of the Internet as everyone knows it.</p><p>“Skycoin has created the foundation for a new decentralized Internet and the most advanced blockchain application platform in the world,” a spokesperson for Skycoin said, adding that over 10,000 hardware nodes have already been deployed for Skywire around the globe. These nodes, part of sophisticated custom hardware and software called Skyminers, form the backbone of this new Internet. More Skyminer nodes coming online means that the potential reach of Skywire is growing.Skywire is designed to be fundamentally faster than the current Internet, as well as much more secure with unprecedented privacy protection. “All traffic on Skywire is encrypted end-to-end,” said a spokesperson. “The technology we’ve developed makes tracking or spying on users literally impossible. The kinds of privacy violations we’ve seen from Facebook and Google simply couldn’t happen on Skywire.” That’s great news for the increasing number of Internet users who are uncomfortable with the invasive and obscure policies of social media companies, and wish to have greater control over who has access to their private data, and how it is used.</p><p>Skywire technology includes putting the hardware infrastructure for Skywire directly into the hands of its users, which will eventually eliminate the need for Internet Service Providers altogether. Operating a low-power Skyminer is as simple as plugging it into a home Internet router, which users are incentivized to do by earning cryptocurrency just for keeping nodes online. Skywire is designed to be hardware agnostic, meaning that people can buy Skyminers directly from Skycoin, or build their own using inexpensive materials available online. Running a Skyminer is an attractive investment for anyone who wishes to help build the Skywire infrastructure, but is not necessary in order to use the network.</p><p>“When Skyminers are attached to antennas, they can begin to link together into a wireless network that doesn’t require traditional Internet access in order to function, and can be accessed freely by any computer or device that can connect to a WiFi signal,” a spokesperson explained.</p><p>Users will not have to choose between two Internets; Skywire will allow access to the existing Internet for those who want the best of both worlds, though the ultimate in speed, privacy and security can only be found on Skywire.</p><p>The nature of Skywire’s decentralized and distributed infrastructure makes it considerably more robust than the current Internet, which has centralized access points through ISPs.</p><p>Skycoin will roll out a public mainnet for Skywire soon, which will mark the final phase in its launch. The first fully-functional large-scale mesh network running Skywire will debut in New York City before the end of the year, with other major cities around the world coming online in the near future as Skywire continues its ambitious worldwide roll-out.</p><p><strong>Interviews may be scheduled via email</strong>: <a href="mailto:drew@skycoin.com">drew@skycoin.com</a></p><p><strong>About Skycoin</strong></p><p>Skycoin is bringing people what they want: a truly decentralized network without any central authority. Founded in 2011 by early developers of Bitcoin and Ethereum, Skycoin quickly grew into an ecosystem of exciting and ambitious projects, including Skywire, the new decentralized Internet; CX, a revolutionary full-featured blockchain application programming language; and the cryptocurrency itself, Skycoin - simple to use, with virtually-free transactions that execute almost instantly. In 2020, Skycoin will release a superior “web-of-trust” blockchain consensus algorithm called Obelisk, which solves the problems inherent to “proof-of-work” and “proof-of-stake” protocols, both of which are slowing down and compromising the integrity of other major cryptocurrencies. For more background, please visit <a href="https://www.skycoin.com" rel="noopener noreferrer" target="_blank">https://www.skycoin.com</a></p><p><strong>Contact:</strong></p><p>Drew Macgibbon <br><a href="mailto:drew@skycoin.com">drew@skycoin.com</a></p><p><strong>SOURCE:</strong> Skycoin</p>',
      },
    },
    releases_october: {
      title: 'Skycoin Project Releases Hardware Development Kit (HDK) for New Cryptocurrency Wallet',
      description: 'Early Bitcoin and Ethereum Developers Set to Roll-Out "Skywire" - a New, Decentralized Internet from Skycoin',
      dates: 'August 23, 2019',
      content: {
        description: '<p>Skycoin is the first cryptocurrency to issue its own hardware wallet, along with a Hardware Development Kit to extend functionality</p><p>Shanghai, China / October 14th, 2019 / The Skycoin Project is pleased to announce the release of a Skywallet Hardware Development Kit (HDK) to anyone interested in extending the functionality of Skywallet, Skycoin’s sleek new hardware cryptocurrency wallet. The HDK is a developer-friendly version of the Skywallet, modified to facilitate programming and testing new code.</p><p>The Skywallet was made to support Skycoin (SKY) and Skycoin Coin Hours (SCH) out of the box, and a future firmware update will enable the Skywallet to hold additional major currencies, including Bitcoin, Ethereum, and more. But with thousands of cryptocurrency coins, tokens, and other assets available for trade, Skycoin wanted to ensure motivated developers had the opportunity to build support into Skywallet for their favourite cryptocurrency.</p><p>The support for additional cryptocurrencies may be accomplished using the HDK and then rolled out to Skywallet users in an optional firmware update, pending approval. The HDK may also be used to create applications that can run on Skywallet. For instance, if a developer wishes to use Skywallet as an authentication device, they could use the HDK to develop that functionality.</p><p>"We made Skywallet the most affordable hardware wallet on the market because we think crypto investors deserve the best security for their investment," said a spokesperson for the project. "We also know there are a lot of cryptocurrencies, and we wanted to give developers the chance to extend the power of Skywallet to their own favourite crypto coin or token."</p><p>The developer-friendly nature of Skywallet extends beyond the Hardware Development Kit to the firmware of the Skywallet itself, which is completely open-source. This means that the security of the Skywallet software may be verified by anyone who wishes to audit the code, because the complete codebase for the firmware is hosted in an open-source repository on <a href="https://github.com/skycoin/hardware-wallet" rel="noopener noreferrer" target="_blank">github</a>.</p><p>More exciting hardware projects from Skycoin, including Skywire antennas and the next generation of Skyminers, will be announced in the coming weeks and months.</p><p>The Skywallet Hardware Development Kit is available to order online at <a href="https://store.skycoin.com/" rel="noopener noreferrer" target="_blank">store.skycoin.com</a> beginning October 14, 2019.</p><p><strong>Media who wish to schedule interviews may reach out to:</strong> <br><strong>Drew MacGibbon</strong> <br><a href="mailto:drew@skycoin.com">drew@skycoin.com</a> <br>+15624529482</p><p> <br></p><hr><p> <br></p><p><strong>About Skycoin:</strong></p><p>Skycoin is bringing people what they want: a truly decentralized network without any central authority. Founded in 2011 by early developers of Bitcoin and Ethereum, Skycoin quickly grew into an ecosystem of exciting and ambitious projects, including <strong>Skywire</strong>, the new decentralized Internet; <strong>CX</strong>, a revolutionary fully-featured blockchain application programming language; and the cryptocurrency itself, <strong>Skycoin</strong> — simple to use, with virtually-free transactions that execute almost instantly.</p><p>In 2020, Skycoin will release a superior "web-of-trust" blockchain consensus algorithm called <strong>Obelisk</strong>, which solves the problems inherent to "proof-of-work" and "proof-of-stake" protocols, both of which are slowing down and compromising the integrity of other major cryptocurrencies.</p><p>For more background, please visit <a href="https://www.skycoin.com" rel="noopener noreferrer" target="_blank">https://www.skycoin.com</a></p>',
      },
    },
    releases_2019_10_17: {
      title: 'Secure and Private “New Internet” Skywire set to Launch in New York City',
      description: 'First Skywire NYC Meetup is a success',
      dates: 'October 17, 2019',
      content: {
        description: '<p><em>First Skywire NYC Meetup is a success</em></p><p><strong>New York City, New York / October 14th, 2019 /</strong> Skycoin held its first Skywire Mainnet Meetup in New York City on Thursday in anticipation of its forthcoming Skywire mesh network. The meeting took place at the NYC Blockchain Center, where Skycoin is a member, and was a great success. The meeting was also live-streamed via YouTube where dozens more watched it live, and several hundred tuned in to watch the final recording.</p><p>Skywire is the Skycoin Project’s new decentralized, private, and end-to-end encrypted internet. It is a mesh network comprised of small antennas attached to nodes called Skyminers. (Skyminers are powerful computers that provide the processing power, storage, and bandwidth for the network.)</p><p>The Skywire network in New York City is being built by members of the Skycoin community who believe in the principles of a free and open Internet, where privacy and security are foundational. Skywire puts the power is firmly in the hands of users, rather than Internet Service Providers, corporations, or advertisers. And unlike other attempts at creating community mesh nets, Skywire is incentivized. This means that Skycoin will pay node operators for their service to the network as a way to encourage growth and adoption of Skywire.</p><p>The ongoing rollout of the New York meshnet across Manhattan is a major milestone and proof-of-concept for the Skycoin Project, which has been working on the “new Internet” for nearly a decade.</p><p>Presenters at the meetup explained the technical details of the Skywire network to attendees, including multi-label packet switching (MPLS), public-key addressing, and software-defined networking, all of which make the Skywire network faster, safer, and more private than the current Internet. A number of antennas were shown as well, including long and short-range antennas. It is these antennas that will allow Skywire nodes to connect to one another across the city, and allow anyone within range to freely join the network.</p><p>The Skywire network will continue to be built over the coming months, growing stronger as more New Yorkers join the effort by deploying Skywire nodes of their own. The nodes themselves are easy to build using readily available parts, or may be purchased directly from skycoin.com.</p><p>Anyone interested in helping out should connect with the New York team via Telegram at t.me/SkycoinNewYork.</p><p><strong>Media who wish to schedule interviews may reach out to:</strong> <br><strong>Khalob Freeborn</strong> <br><a href="mailto:khalob@skycoin.comm">khalob@skycoin.com</a> <br>+14243542994</p><p> <br></p><hr><p> <br></p><p><strong>About Skycoin:</strong></p><p>Skycoin is bringing people what they want: a truly decentralized network without any central authority. Founded in 2011 by early developers of Bitcoin and Ethereum, Skycoin quickly grew into an ecosystem of exciting and ambitious projects, including <strong>Skywire</strong>, the new decentralized Internet; <strong>CX</strong>, a revolutionary fully-featured blockchain application programming language; and the cryptocurrency itself, <strong>Skycoin</strong> — simple to use, with virtually-free transactions that execute almost instantly.</p><p>In 2020, Skycoin will release a superior "web-of-trust" blockchain consensus algorithm called <strong>Obelisk</strong>, which solves the problems inherent to "proof-of-work" and "proof-of-stake" protocols, both of which are slowing down and compromising the integrity of other major cryptocurrencies.</p><p>For more background, please visit <a href="https://www.skycoin.com" rel="noopener noreferrer" target="_blank">https://www.skycoin.com</a></p>',
      },
    },
    releases_2019_11_26: {
      title: 'Skycoin Project Releases Affordable High-Security Hardware Wallet',
      description: 'Skycoin is the first cryptocurrency to issue its own hardware wallet.',
      dates: 'November 26, 2019',
      content: {
        description: '<p><em>Skycoin is the first cryptocurrency to issue its own hardware wallet.</em></p><p><em>Shanghai, China</em> — Skycoin is pleased to announce the immediate availability of <strong><em>Skywallet</em></strong>, a sleek and sophisticated cryptocurrency hardware wallet designed specifically with Skycoin in mind.</p><p>Skywallet was made to support Skycoin (SKY) and Skycoin Coin Hours (SCH) out of the box, and a future firmware update will enable the Skywallet to hold many different coins and tokens, including Bitcoin, Ethereum, and more. In addition, a Hardware Development Kit (HDK) is available to developers who wish to further extend the Skywallet’s functionality.</p><p>Skywallet is initially available in three different colors (black, white, and silver) for just $39.00 USD each. Despite the massive price drop relative to competition, no corners have been cut on ensuring that these devices are secure. In fact, the Skycoin team uncovered and resolved significant flaws in the firmware code of one of the most popular devices currently available.</p><p>“We wanted everyone to have an affordable option for securely protecting their Skycoin investment,” said a spokesperson for the project.</p><p>Unlike mobile or desktop software wallets, the seed phrase (or “private key”) that generates the Skycoin address on the Skywallet is never exposed to a computer or the Internet, and cannot be accessed or hijacked by an attacker.<strong>This means the Skywallet is completely private and secure</strong>, even if one’s personal computer or Internet connection is compromised.</p><p>The security of the Skywallet software may be verified by anyone who wishes to audit the code, because the complete codebase for the firmware is hosted in an open-source repository on <a href="https://github.com/skycoin/hardware-wallet" rel="noopener noreferrer" target="_blank">GitHub</a>.</p><p>The Skycoin team is uniquely qualified to produce Skywallets, as they have nearly a decade of experience building both hardware and software solutions to some of blockchain’s most intractable problems. Skycoin’s existing hardware products include approximately 10,000 Skyminer nodes deployed around the world, forming the telecommunications infrastructure of Skycoin’s new encrypted internet: Skywire.</p><p>More exciting hardware projects, including Skywire antennas and the next generation of Skyminers, will be announced in the coming weeks and months.</p><p>The Skywallet is available to order online at &nbsp; <a href="https://store.skycoin.com/" rel="noopener noreferrer" target="_blank">store.skycoin.com</a> beginning November 28, 2019.</p><p>Media who wish to schedule interviews may reach out to:&nbsp;</p><p>Tiffany</p><p> <a href="mailto:mktcn@skycoin.com">mktcn@skycoin.com</a></p><p>0085263533831</p><p> <br></p><hr><p> <br></p><p><strong>About Skycoin:</strong></p><p>Skycoin is bringing people what they want: a truly decentralized network without any central authority. Founded in 2011 by early developers of Bitcoin and Ethereum, Skycoin quickly grew into an ecosystem of exciting and ambitious projects, including <strong>Skywire</strong>, the new decentralized Internet; <strong>CX</strong>, a revolutionary fully-featured blockchain application programming language; and the cryptocurrency itself, <strong>Skycoin</strong> — simple to use, with virtually-free transactions that execute almost instantly.</p><p>In 2020, Skycoin will release a superior "web-of-trust" blockchain consensus algorithm called <strong>Obelisk</strong>, which solves the problems inherent to "proof-of-work" and "proof-of-stake" protocols, both of which are slowing down and compromising the integrity of other major cryptocurrencies.</p><p>For more background, please visit <a href="https://www.skycoin.com" rel="noopener noreferrer" target="_blank">https://www.skycoin.com</a></p>',
      },
    },
  },
  sky_wallet: {
    title: 'Skywallet - Skycoin`s New Hardware Wallet',
    description: 'Skywallet - New Hardware Wallet',
    about: {
      heading: 'Skywallet',
      subheading: 'Skycoin`s New Hardware Wallet',
      paragraph: 'When you store or access your cryptocurrency, you are your own bank, so the process should be simple and intuitive. Your hardware wallet is your bank vault and it should feel like a premium and secure device. We’ve spent months iterating over designs and incorporating user feedback in order to make Skywallet the best hardware wallet experience on the market.',
    },
    features: {
      heading: 'Getting started',
      recoveryseed: {
        title: 'Recovery seed',
        text:
          'The recovery seed is a backup for your entire device. If your device is lost or damaged, you can recover your wallets using the seed phrase. It is generated on your device and only shown once. It should go without saying that if somebody finds your seed, they can easily clone your device. Do not store the seed or communicate it digitally. Support will never ask for your seed.',
      },
      instructions: {
        title: 'Instructions',
        text:
          'Before connecting to your computer, please ensure that you have the latest version of the skycoin desktop wallet installed available at skycoin.com/downloads. If it is already installed, simply plug your device into your computer and follow the instructions on screen.',
      },
      treatment: {
        title: 'Treatment',
        text:
          'Do not expose the wallet to extreme temperatures or elements. It is not waterproof, heat or acid resistant.',
      },
      download: {
        title: 'Download',
        text:
          '<p>Download the Skywallet user manual here:</p><p> <a href="https://s3-ap-southeast-1.amazonaws.com/downloads.skycoin.com/skywallet/Skywallet-User_Manuals_Draft_1_c.pdf" rel="noopener noreferrer" target="_blank">User Manual</a></p><p>Download the Desktop Wallet and the Skywallet Daemon here:</p><p> <a href="/ja/downloads/">https://skycoin.com/downloads/</a></p>',
      },
    },
    roadmap: 'CX Roadmap',
  },
  skywallethdk: {
    title: 'Skywallet HDK',
    description: 'Skywallet HDK - Make your favourite token compatible with Skywallet',
    about: {
      heading: 'Skywallet HDK',
      subheading: 'Make your favourite token compatible with Skywallet',
      paragraph: '<p>The Skywallet HDK (Hardware Development Kit) is the developer-friendly version of the Skywallet hardware that is intended to make it easy to create applications, or integrate other cryptocurrencies and tokens into the Skywallet.</p><p>There are several key differences between the Skywallet and the Skywallet HDK that make the HDK easier to use for developers. The Skywallet HDK:</p><ul> <li>Does not have a case around the circuit board</li><li>Is physically bigger than the small, sleek consumer-facing Skywallet</li><li>Features larger buttons that are easier to work with</li><li>Has a 6-pin socket for ST programmer</li><li>Does not have a pre-flashed bootloader</li></ul><p>The primary use of the Skywallet HDK is to build capability into Skywallet to support cryptocurrencies beyond Skycoin and Skycoin Coin Hours. The HDK may also be used to create additional programs that may run on Skywallet. If a developer wishes to use Skywallet as an authentication device, for instance, they can use the HDK to develop that functionality.</p><p>All new programs and token compatibilities which are developed on the Skywallet HDK can be submitted to Skycoin for review. If approved, your update will be pushed out to all current Skywallet holders who can opt-in to the new functionality.</p><p>If you would like to extend the functionality and capability of Skywallet for all its users, grab a Skywallet HDK and get coding!</p>',
    },
    features: {
      heading: 'Getting started',
      instructions: {
        title: 'Instructions',
        text: '<p>Join the Telegram room <a href="https://t.me/SkycoinDevelopers" rel="noopener noreferrer" target="_blank">&commat;SkycoinDevelopers</a> or file an issue on Github if you want to get in touch with the development team.</p>',
      },
      treatment: {
        title: 'Treatment',
        text:
          'Do not expose the wallet to extreme temperatures or elements. It is not waterproof, heat or acid resistant.',
      },
      download: {
        title: 'Download',
        text:
          '<ul> <li> <a href="https://github.com/skycoin/hardware-wallet" rel="noreferrer nofollow" target="_blank">https://github.com/skycoin/hardware-wallet</a> </li><li> <a href="https://github.com/skycoin/hardware-wallet-daemon" rel="noreferrer nofollow" target="_blank">https://github.com/skycoin/hardware-wallet-daemon</a> </li><li> <a href="https://github.com/skycoin/hardware-wallet-go" rel="noreferrer nofollow" target="_blank">https://github.com/skycoin/hardware-wallet-go</a> </li></ul>',
      },
      documentation: {
        title: 'Documentation and codebase',
        text:
          '<ul> <li> <a href="https://github.com/skycoin/User-Manuals/tree/master/Skywallet" rel="noopener noreferrer" target="_blank">https://github.com/skycoin/User-Manuals/tree/master/Skywallet</a> </li><li> <a href="https://github.com/skycoin/hardware-wallet" rel="noopener noreferrer" target="_blank">https://github.com/skycoin/hardware-wallet</a> </li><li> <a href="https://github.com/skycoin/hardware-wallet-daemon" rel="noopener noreferrer" target="_blank">https://github.com/skycoin/hardware-wallet-daemon</a> </li><li> <a href="https://github.com/skycoin/hardware-wallet-go" rel="noopener noreferrer" target="_blank">https://github.com/skycoin/hardware-wallet-go</a> </li></ul>',
      },
    },
    gallery: {
      title: 'Gallery',
      description: 'Gallery',
      heading: 'Gallery',
      skywallethdk: {
        heading: 'Gallery',
      },
    },
  },
  cxchains: {
    title: 'CX Chains Overview',
  },
};

/* eslint-enable max-len */



// WEBPACK FOOTER //
// ./src/locales/ja.js